/** Stub for web */
export const setSystemBrightness = async (value: number) => undefined;
